import { cn } from "@/lib/utils";
import type { NormalizedEvent } from "@/services/types/agent-gateway";
import { SafeMarkdown } from "./SafeMarkdown";
import {
  formatEventAuthor,
  formatEventTime,
  isUserAuthor,
} from "./event-utils";

type MessageEvent = Extract<NormalizedEvent, { type: "message" }>;

export function AgentMessage({ event }: { event: MessageEvent }) {
  const userMessage = isUserAuthor(event.author);
  const author = formatEventAuthor(event.author);

  return (
    <article
      aria-label={`Message from ${author}`}
      className={cn(
        "flex min-w-0",
        userMessage ? "justify-end" : "justify-start",
      )}
    >
      <div
        className={cn(
          "min-w-0 max-w-[88%] rounded-2xl px-4 py-3 text-sm shadow-xs md:max-w-[75%]",
          userMessage
            ? "rounded-br-md bg-brand-darkGreen text-white"
            : "rounded-bl-md border border-slate-200 bg-white text-slate-800",
        )}
      >
        <div className="mb-2 flex min-w-0 flex-wrap items-center justify-between gap-x-4 gap-y-1 text-xs opacity-70">
          <span className="font-medium [overflow-wrap:anywhere]">{author}</span>
          <time className="shrink-0" dateTime={event.created_at ?? undefined}>
            {formatEventTime(event.created_at)}
          </time>
        </div>

        {userMessage ? (
          <p className="whitespace-pre-wrap [overflow-wrap:anywhere]">
            {event.content.text}
          </p>
        ) : (
          <SafeMarkdown>{event.content.text}</SafeMarkdown>
        )}
      </div>
    </article>
  );
}
